import * as z from "zod";

export const ThreeDSTokenResponseSchema = z.discriminatedUnion("Enabled", [
  z.object({ Enabled: z.literal(false) }),
  z.object({
    Enabled: z.literal(true),
    AccessToken: z.string(),
    TokenType: z.string().optional(),
    ExpiresIn: z.string().optional(),
    EstablishmentCode: z.number().optional(),
    MerchantName: z.string().optional(),
    MCC: z.number().optional(),
    DeviceIpAddress: z.string().nullable().optional(),
    Context: z.record(z.string(), z.unknown()).optional(),
  }),
]);
